import { SectionType } from '../enums/mediaTypes.ts';

export const isPerson = (type: SectionType): type is SectionType.Person => type === SectionType.Person;
